let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a9gYT")).then(() => parcelRequire('arEu0'));